export default "__VITE_ASSET__6810c460__"